import React from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import ModalContainer from '../../../../components/ModalContainer';

const GenerateApiKeyModal = ({
  isOpenGenerateModal,
  modalApiKeyNameInvalid,
  modalApiKeyName,
  onCloseModal,
  onChangeModalInput,
  onClickModalGenerateBtn,
}) => {
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalWidthType="modal-500px"
      openModal={isOpenGenerateModal}
      closeModal={() => onCloseModal('generate')}
    >
      <div className="header">
        {/* Generate API key */}
        <div className="title">{t('608c815be4')}</div>
      </div>
      <div className="body">
        {/* API key name */}
        <div className="modal-form-title required">{t('1a1d8746f6')}</div>
        <div className="modal-form-field">
          <Input
            type="text"
            style={{
              borderColor: modalApiKeyNameInvalid ? 'red' : '#ced4da',
            }}
            placeholder={t('7563cde047')}
            autoComplete="new-email1"
            value={modalApiKeyName}
            onChange={e => onChangeModalInput(e.target.value)}
          />
          <span>{t('1566b465c6')}</span>
        </div>
      </div>
      <div className="footer non-border-top-footer">
        {/* Generate */}
        <Button
          label={t('de3e350386')}
          className="btn-submit"
          disabled={modalApiKeyNameInvalid || !modalApiKeyName}
          onClick={() => onClickModalGenerateBtn()}
        />
      </div>
    </ModalContainer>
  );
};

export default React.memo(GenerateApiKeyModal);
